import { connect } from 'react-redux'

import { RouteDebugTable } from '../../../../components'

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ routes, debugData }, { routeId }) => ({
    route: routes[routeId],
    debugData: debugData[routeId],
})

export default connect(mapStateToProps)(RouteDebugTable)
